// TODO = make tabId dynamic once the tabId flow is completed from the backend
export const tableSwitchTabId = '614d78e7-ffc3-469e-bc86-7f674bc720c8';

/**
 * Used as function because if we directly assign this to forms then we should reset the forms in ngOnDestroy
 * as the previous values of forms is stored in this variable if not made a function.
 */
export const subLinkFormControls = () =>
  new FormGroup({
    clientId: new FormControl(''),
    attachType: new FormControl(''),
    attachTypeSection: new FormControl(''),
    section: new FormControl(''),
    tab: new FormControl(''),
    freezePane: new FormControl(false),
  });

export const tableHeaderFilterControls = (
  additionalControls: Record<string, unknown> = {},
) =>
  new FormGroup({
    groupType: new FormControl(''),
    showStatus: new FormControl(''),
    markStatus: new FormControl(''),
    visibilityFilter: new FormControl('HIDE_ALL'),
    orderBy: new FormControl('FILE_ORDER'),
    sortByReference: new FormControl('ASC'),
    searchOrderBy: new FormControl(''),
    auditViewDocType: new FormControl('UNATTACHED'),
    docStatus: new FormControl(''),
    tagId: new FormControl(''),
    docInterval: new FormControl(''),
    lastUserToUpdate: new FormControl(false),
    ...additionalControls,
  });

export const searchFilterControls = () =>
  new FormGroup({
    searchFilter: new FormControl(''),
  });

/** Modify for backend, if incase BE asked to change key, you can use directly form the apiQueryParams */
export const apiQueryParamsMapping = {
  sortByReference: 'sortBy',
};

export const tableSwitcherPaginationControls = () =>
  new FormGroup({
    pages: new FormControl(''),
  });

export const SublinkFreezePaneOption = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const DocumentTransferSuccessMssgMap: Record<ForceAny, string> = {
  COPY: 'Document has been copied successfully',
  MOVE: 'Document has been moved successfully',
  ATTACH: 'Document has been attached successfully',
};

/**
 * @important Donot change or alter any pre-existing keys as it may alter the functionality of
 * Copy, Move and Attach in Document's page.
 */
export enum ATTACH_TYPE_OPTION {
  ATTACH_TO_AIRCRAFT = 'Attach To Aircraft',
  ATTACH_TO_ENGINES = 'Attach To Engines',
  ATTACH_TO_GEARS = 'Attach To Gears',
  ATTACH_TO_APU = 'Attach To APU',
  ATTACH_TO_THRUST_REVERSER = 'Attach To Thrust Reverser',
  ATTACH_TO_PROPELLER = 'Attach To Propeller',
  ATTACH_TO_MCC = 'Attach To Maintenance Control Centre',
  ATTACH_TO_INTERNAL_DOCUMENTS = 'Attach To Internal Documents',
  ATTACH_TO_COMPLIANCE_MATRIX = 'Attach To AD/SB/MOD/STC Compliance Matrix',
  ATTACH_TO_MANAGE_COMPONENT = 'Attach To Manage Component', // NOT SEEN IN MCC
}

export type AttachTypeLabelKey = keyof typeof ATTACH_TYPE_OPTION;

export type View = 'COPY' | 'ATTACH' | 'ATTACH_TO_MANAGE_COMPONENT';

export const CONST_MH_ATTACH_OPTIONS: AttachTypeLabelKey[] = [
  'ATTACH_TO_AIRCRAFT',
  'ATTACH_TO_ENGINES',
  'ATTACH_TO_GEARS',
  'ATTACH_TO_APU',
  'ATTACH_TO_THRUST_REVERSER',
  'ATTACH_TO_PROPELLER',
];

export const getAttachTypeOptionsForView = (
  view: View,
): Record<string, ATTACH_TYPE_OPTION> => {
  const map: Record<View, AttachTypeLabelKey[]> = {
    COPY: [
      ...CONST_MH_ATTACH_OPTIONS,
      'ATTACH_TO_INTERNAL_DOCUMENTS',
      'ATTACH_TO_COMPLIANCE_MATRIX',
    ],
    ATTACH: [
      ...CONST_MH_ATTACH_OPTIONS,
      'ATTACH_TO_MCC',
      'ATTACH_TO_INTERNAL_DOCUMENTS',
    ],
    ATTACH_TO_MANAGE_COMPONENT: ['ATTACH_TO_MANAGE_COMPONENT'],
  };

  return Object.fromEntries(
    map[view].map((k) => [
      k,
      ATTACH_TYPE_OPTION[k as keyof typeof ATTACH_TYPE_OPTION],
    ]),
  );
};

export enum ENGINE_TYPE_OPTION {
  ENGINE_FLEET_STATUS = 'Engine Fleet Status',
  ENGINE_MODULE_FLEET = 'Engine Module Fleet',
  ENGINE_STAND_TYPE = 'Engine Stand Type',
}

export enum GEAR_TYPE_OPTION {
  LANDING_GEAR_FLEET = 'Landing Gear Fleet Status',
  LANDING_GEAR_SUB_ASSEMBLY = 'Landing Gear Sub-Assembly Fleet',
}

export const subLinkTabs = [
  {
    label: '',
    value: 'thumbnail-view',
    icon: 'pi pi-th-large',
    activeStyleClass: 'active-tab-menu-icon',
    toolTipText: 'Thumbnail View',
  },
  {
    label: '',
    value: 'list-view',
    icon: 'pi pi-align-justify',
    activeStyleClass: 'active-tab-menu-icon',
    toolTipText: 'List View',
  },
  {
    label: '',
    value: 'mixed-view',
    imgSrc: '/assets/images/icons/mixed-view.svg',
    imgStyle: { width: '15px' },
    activeStyleClass: 'active-tab-menu-image',
    toolTipText: 'Mixed View',
  },
];

export const tableViewSwitcherManageDocumentMenu = (
  context: ForceAny,
  manageDocumentFeature?: MANAGE_DOC_MENU_KEYS[],
) => {
  const options = [
    {
      id: MANAGE_DOC_MENU_KEYS.RECORDER,
      label: 'Reorder Documents',
    },
    {
      id: MANAGE_DOC_MENU_KEYS.COPY,
      label: 'Copy',
      selectedText: 'Copy',
      action: () => {},
    },
    {
      id: MANAGE_DOC_MENU_KEYS.COPY_GROUP,
      label: 'Copy To Other Group',
      selectedText: 'Copy To Other Group',
      action: () => {},
    },
    {
      id: MANAGE_DOC_MENU_KEYS.MOVE,
      label: 'Move',
      selectedText: 'Move',
      action: () => {},
    },
    {
      id: MANAGE_DOC_MENU_KEYS.ATTACH,
      label: 'Attach Status To Entry',
      selectedText: 'Attach Status To Entry',
      action: () => {},
    },
    {
      id: MANAGE_DOC_MENU_KEYS.DEFAULT_ATTACH,
      label: 'Attach',
      selectedText: 'Attach',
      action: () => {},
    },
    {
      id: MANAGE_DOC_MENU_KEYS.DELETE,
      label: 'Delete',
      action: () => {
        context.onManageDocumentMenuClick.emit({
          id: MANAGE_DOC_MENU_KEYS.DELETE,
        });
        context.handleMenuOptionClick('delete');
      },
    },
    {
      id: MANAGE_DOC_MENU_KEYS.RELOAD,
      label: 'Reload',
      action: () => {
        context.onManageDocumentMenuClick.emit({
          id: MANAGE_DOC_MENU_KEYS.RELOAD,
        });
        context.handleMenuOptionClick('reload');
      },
    },
    {
      id: MANAGE_DOC_MENU_KEYS.MERGE,
      label: 'Merge',
      selectedText: 'Merge/Manage Documents',
      action: () => {
        context.onManageDocumentMenuClick.emit({
          id: MANAGE_DOC_MENU_KEYS.MERGE,
        });
      },
    },
    {
      id: MANAGE_DOC_MENU_KEYS.MERGE_SHAREFILE,
      label: 'Merge through ShareFile',
      selectedText: 'Merge through ShareFile',
      action: () => {
        context.onManageDocumentMenuClick.emit({
          id: MANAGE_DOC_MENU_KEYS.MERGE_SHAREFILE,
        });
      },
    },
    {
      id: MANAGE_DOC_MENU_KEYS.PRINT,
      label: 'Print ',
      selectedText: 'Print',
      action: () => {
        context.onManageDocumentMenuClick.emit({
          id: MANAGE_DOC_MENU_KEYS.PRINT,
        });
        context.handlePrintClick();
      },
    },
    {
      permissionKey: 'SPLIT', // Sent as action in permission JSON.
      id: MANAGE_DOC_MENU_KEYS.SPLIT,
      label: 'Split/Extract',
      selectedText: 'Split/Extract Documents',
      action: () => {
        context.onManageDocumentMenuClick.emit({
          id: MANAGE_DOC_MENU_KEYS.SPLIT,
        });
      },
    },
    {
      id: MANAGE_DOC_MENU_KEYS.DOWNLOAD,
      label: 'Download to PC',
      action: () => {
        context.onManageDocumentMenuClick.emit({
          id: MANAGE_DOC_MENU_KEYS.DOWNLOAD,
        });
        void context.handleDownloadClick();
      },
    },
    {
      id: MANAGE_DOC_MENU_KEYS.DOWNLOAD_SHAREFILE,
      label: 'Download through Sharefile',
      action: () => {},
    },
    {
      id: MANAGE_DOC_MENU_KEYS.SET_ARCHIVE,
      label: 'Set to Archive',
      action: () => {
        context.onManageDocumentMenuClick.emit({
          id: MANAGE_DOC_MENU_KEYS.SET_ARCHIVE,
        });
      },
    },
    {
      id: MANAGE_DOC_MENU_KEYS.AUDIT_TRAIL,
      label: 'Audit Trail',
      action: () => {
        context.onManageDocumentMenuClick.emit({
          id: MANAGE_DOC_MENU_KEYS.AUDIT_TRAIL,
        });
      },
    },
    {
      id: MANAGE_DOC_MENU_KEYS.ADD_FLYDOC_TEMPLATE,
      label: 'Add flydoc template',
      action: () => {
        context.onManageDocumentMenuClick.emit({
          id: MANAGE_DOC_MENU_KEYS.ADD_FLYDOC_TEMPLATE,
        });
      },
    },
  ] as ButtonDropdownItem<MANAGE_DOC_MENU_KEYS>[];

  const features = manageDocumentFeature;

  const filteredOptions = options.filter((option) =>
    features?.includes(option.id as MANAGE_DOC_MENU_KEYS),
  );
  return filteredOptions;
};

export enum TABLE_SWITCHER_CHECKBOX_VALS {
  USE = 'USE',
  REJECT = 'REJECT',
  DELETE = 'DELETE',
  APPROVED = 'APPROVE',
  UNMARK = 'UN_MARK',
  QUERIED = 'QUERIED',
  REVIEWED = 'REVIEWED',
  DEFAULT = 'DEFAULT',
}

export enum TABLE_SWITCHER_CHECKBOX_VALS_FILTERS {
  USE = 'Use',
  REJECT = 'Reject',
  DELETE = 'Delete',
  APPROVE = 'Approved',
  UN_MARK = 'Un Mark',
}

export const tableViewSwitcherStatusDoc = [
  { label: 'Use', value: TABLE_SWITCHER_CHECKBOX_VALS.USE },
  { label: 'Reject', value: TABLE_SWITCHER_CHECKBOX_VALS.REJECT },
  { label: 'Delete', value: TABLE_SWITCHER_CHECKBOX_VALS.DELETE },
  { label: 'Approved', value: TABLE_SWITCHER_CHECKBOX_VALS.APPROVED },
  { label: 'Un Mark', value: TABLE_SWITCHER_CHECKBOX_VALS.UNMARK },
];

export const tableViewSwitcherItemColorMapping: Record<string, string> = {
  USE: '#9DC2FF',
  REJECT: '#E93535',
  DELETE: '#FFFF00',
  APPROVE: '#A9D3AB',
  UN_MARK: '#e7e8ea',
  QUERIED: '#FF9900',
  REVIEWED: '#b4c7ee',
  DELETED: '#FECACA',
  ACTIVE: '#E7E8EA',
};

export enum PAGE_SELECT_FILTER {
  CURRENT_PAGE = 'Current Page',
  ALL_PAGE = 'All Pages',
}

export const pageSelectFilter = [
  { label: 'Current Page', value: PAGE_SELECT_FILTER.CURRENT_PAGE },
  { label: 'All Pages', value: PAGE_SELECT_FILTER.ALL_PAGE },
];

export const tableViewSwitcherFileExtensionMapper: Record<string, string> = {
  '.pdf': '/assets/images/PDF_THUMB.png',
  '.txt': '/assets/images/TEXT_logo.png',
  '.ppt': '/assets/images/DOCX_File.png',
  '.pptx': '/assets/images/DOCX_File.png',
  '.BMP': '/assets/images/IMAGE_THUMB.jpg',
  '.bmp': '/assets/images/IMAGE_THUMB.jpg',
  '.xlsm': '/assets/images/DOCX_File.png',
  '.mp4': '/assets/images/VIDEO_THUMB.jpeg',
  '.mov': '/assets/images/VIDEO_THUMB.jpeg',
  '.vob': '/assets/images/VIDEO_THUMB.jpeg',
  '.wmv': '/assets/images/VIDEO_THUMB.jpeg',
  '.mpg': '/assets/images/VIDEO_THUMB.jpeg',
  '.mkv': '/assets/images/VIDEO_THUMB.jpeg',
  '.jpg': '/assets/images/IMAGE_THUMB.jpg',
  '.jpeg': '/assets/images/IMAGE_THUMB.jpg',
  '.avi': '/assets/images/VIDEO_THUMB.jpeg',
  '.flv': '/assets/images/VIDEO_THUMB.jpeg',
  '.tiff': '/assets/images/IMAGE_THUMB.jpg',
  '.rtf': '/assets/images/TEXT_logo.png',
  '.tif': '/assets/images/IMAGE_THUMB.jpg',
  '.docx': '/assets/images/DOCX_File.png',
  '.csv': '/assets/images/CSV-Thumb.png',
  '.doc': '/assets/images/DOCX_File.png',
  '.xls': '/assets/images/Excel2007Logo_small.png',
  '.xlsx': '/assets/images/Excel2007Logo_small.png',
  '.flydoc': '/assets/images/flydocs_template.png',
};

export const tableViewSwitcherDocDeleteToastConfig = {
  summary: 'Delete Sublink Document?',
  detail: 'Are you sure you want to delete this Document?',
  severity: 'error',
  sticky: true,
};

export enum TABLE_VIEW_SWICHER_CHECKBOX_VALS {
  USE = 'USE',
  REJECT = 'REJECT',
  DELETE = 'DELETE',
  APPROVED = 'APPROVE',
  UNMARK = 'UN_MARK',
}

import { FormGroup, FormControl } from '@angular/forms';
import { ButtonDropdownItem } from '../../shared/components/button/button.component';
import { ForceAny } from '../../shared/typescript';

export enum MANAGE_DOC_MENU_KEYS {
  MANAGE_DOCUMENTS = 'MANAGE_DOCUMENTS',
  RECORDER = 'REORDER_DOCUMENTS',
  ATTACH = 'ATTACH',
  COPY = 'COPY',
  MOVE = 'MOVE',
  DELETE = 'DELETE',
  RELOAD = 'RELOAD',
  PRINT = 'PRINT',
  MERGE = 'MERGE',
  SPLIT = 'SPLIT/EXTRACT',
  DOWNLOAD = 'DOWNLOAD_TO_PC',
  SET_ARCHIVE = 'SET_ARCHIVE',
  AUDIT_TRAIL = 'AUDIT_TRAIL',
  RENAME = 'RENAME',
  RENAME_FOLDER = 'RENAME_FOLDER',
  REPLACE_DOCUMENT = 'REPLACE_DOCUMENT',
  DEFAULT_ATTACH = 'DEFAULT_ATTACH',

  ACTIONS_PERMISSION = 'ACTIONS_PERMISSION',
  SELECTED_DOCUMENTS = 'selected-documents',
  ADD_FLYDOC_TEMPLATE = 'add flydoc template',
  COPY_GROUP = 'COPY_GROUP',
  MERGE_SHAREFILE = 'MERGE_SHAREFILE',
  DOWNLOAD_SHAREFILE = 'DOWNLOAD_SHAREFILE',
  PREVIEW_GENERATOR = 'PREVIEW_GENERATOR',
  CREATE_BOX = 'CREATE_BOX',
  MERGE_FOLDER = 'MERGE_FOLDER',
}

export enum MH_MANAGE_DOC_MENU_KEYS {
  ADD_BOX = 'add-box',
  MOVE_COPY = 'move-copy',
  DELETE = 'delete',
  RELOAD = 'reload',
  MERGE = 'merge',
  DOWNLOAD_TO_PC = 'download-to-pc',
  AUDIT_TRAIL = 'audit-trail',
  UPLOAD_PHYSICAL_BOX_NUMBER = 'physicalBoxNum',
  FLY_TRAWL = 'FLY_TRAWL',

  ALL_PERMISSION = 'all',
  SEARCH = 'search',
  REORDER = 'reorder',
  RENAME = 'rename',
  SET_ARCHIVE = 'set-archive',
  MH_MANAGE_DOCUMENTS = 'mh-manage-documents',
  UPLOAD_DOC = 'upload-doc',
  BASIC_FUNCTIONS = 'BASIC_FUNCTIONS',
  ADVANCED_FUNCTIONS = 'ADVANCED_FUNCTIONS',
  DOCUMENT_FUNCTIONS = 'DOCUMENT_FUNCTIONS',
  SPLIT = 'SPLIT/EXTRACT',
  RENAME_DOCUMENT = 'RENAME_DOCUMENT',
  RENAME_FOLDER = 'rename-folder',
  CREATE_FOLDER = 'createFolder',
  REPLACE_DOCUMENT = 'REPLACE_DOCUMENT',
  ATTACH = 'ATTACH',
  PREVIEW = 'PREVIEW',
  RECORDER = 'REORDER_DOCUMENTS',
  MERGE_FOLDER = 'MERGE_FOLDER',
}

export const subLinkFilterTooltipShowText =
  'Filter the page to only show documents with the chosen document status. i.e. Select Approved to show all documents with the status Approved.';

export const subLinkFilterTooltipMarkText =
  'Use to update the document status for all documents to the chosen status.';

export const tableSwitcherPageTooltip =
  'Use this function only if you want to select all files to save them to your desktop or other similar function.  Using this option does not change the colour status of any file.';

export const withLoginPdfUrlTooltip =
  'Select an option to allow user to access the URL with/without login.';

export enum ACTION_ICON_KEYS {
  COMMENT = 'comment',
  RENAME = 'RENAME_DOCUMENT',
  PREVIEW = 'preview',
  ROTATE_CLOCK = 'rotate-clock-wise',
  ROTATE_ANTI_CLOCK = 'rotate-anti-clock-wise',
  EDIT_META_FILE = 'edit-meta-file',
  REPLACE_DOCUMENT = 'REPLACE_DOCUMENT',
  PDF_URL = 'pdf-url',
  RELOAD_DOCUMENT = 'RELOAD',
  OPEN_FOLDER = 'open-folder',
  SHOW_NEXT_FILE = 'show-next-file',
  SHOW_PREVIOUS_FILE = 'show-previous-file',
  VIEW_DETAIL = 'view-detail',
  TICK = 'tick',
  CROSS = 'cross',
  EDIT_META_FILE_DOCUMENT = 'edit-meta-file-document',
  CUSTOM_EVENT_OPEN_FOLDER = 'custom-event-open-folder',
}

export enum ROW_VISIBILITY_FILTER {
  HIDE_ALL = 'Hide All',
  SHOW_ALL = 'Show All',
  SHOW_DELETED = 'Show Deleted',
  SHOW_ARCHIVED = 'Show Archived',
}

export enum MID_ROW_VISIBILITY_FILTER {
  HIDE_ALL = 'Hide All',
  SHOW_ALL = 'Show All',
  SHOW_DELETED = 'Show Deleted',
  SHOW_MOVED = 'Show Moved',
  SHOW_ARCHIVED = 'Show Archived',
}

export enum MDT_DOCUMENT_STATUS_FILTER {
  APPROVED = 'SHOW APPROVED',
  REJECTED = 'SHOW REJECTED',
  PENDING = 'UNPROCESSED',
}

export enum MDT_DATE_TAGGING_FILTER {
  '1 Day' = '1 Day',
  '2 Days' = '2 Days',
  '5 Days' = '5 Days',
  '10 Days' = '10 Days',
  '1 Week' = '1 Week',
  '2 Weeks' = '2 Weeks',
  '1 Month' = '1 Month',
  '2 Months' = '2 Months',
  '3 Months' = '3 Months',
}

export enum ENUM_ORDER_BY {
  FILE_ORDER = 'File Order',
  FILE_ID = 'File ID',
  FILE_NAME = 'File Name',
  MCC_ROWS = 'MCC Rows',
}

export enum ENUM_FILTER_BY {
  SELECT_FILTER = 'Select Filter',
  BY_REFERENCE_NUMBER = 'By Reference Number',
}

export enum ENUM_SORT_BY {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum ENUM_AUDIT_VIEW_TYPE {
  UNATTACHED = 'Unattached Documents',
  ATTACHED = 'Attached Documents',
}

/** * MOVE / COPY Constant goes here.... */
export const copyMoveEngineModuleOptions = [
  {
    label: 'Engine Fleet Status',
    value: 'ENGINE_FLEET_STATUS',
  },
  {
    label: 'Engine Module Fleet',
    value: 'ENGINE_FLEET_MODULE',
  },
  {
    label: 'Engine Stand Type',
    value: 'ENGINE_STAND_TYPE',
  },
];

export const copyMoveLandingGearModuleOptions = [
  {
    label: 'Landing Gear Fleet Status',
    value: 'LANDING_GEAR_FLEET_STATUS',
  },
  {
    label: 'Landing Gear Sub-Assembly Fleet',
    value: 'LANDING_GEAR_SUB_ASSEMBLY_FLEET',
  },
];

/**
 * @description The ordering of form Controls is crucial here and should be ordered
 * with respective to its position in form (from top to bottom).
 */
export const defaultCopyMoveTableSwitcherFormConst = {
  clientId: [''],
  attachType: [''],
  attachTypeSection: [''],
  componentType: [''], // For now used for MCC Transfer
  component: [''],
  tab: [''],
  tabName: [''],
  tabMenu: [''],
  tabSubMenu: [''],
  group: [''],
  date: [''],
};

export const createFleetConfig = (
  endpoint: string,
  name: string,
): [string, string, string] => [
  `${endpoint}/fleet-status`,
  'FLEET_STATUS',
  name,
];

export const copyMoveFilterAttachConfig: Record<
  string,
  [string, string, string]
> = {
  ATTACH_TO_AIRCRAFT: createFleetConfig('aircraft', 'Aircrafts'),
  ATTACH_TO_APU: ['apu/fleet-status', 'FLEET_STATUS', 'APUs'],
  ATTACH_TO_THRUST_REVERSER: [
    'thrust/fleet-status',
    'FLEET_STATUS',
    'Thrust Reversers',
  ],
  ATTACH_TO_PROPELLER: ['propeller/fleet-status', 'FLEET_STATUS', 'Propellers'],
  ENGINE_FLEET_STATUS: ['engine/fleet-status', 'FLEET_STATUS', 'Engines'],
  ENGINE_FLEET_MODULE: [
    'engine/fleet-status',
    'MODULE_FLEET',
    'Engine Module Fleets',
  ],
  ENGINE_STAND_TYPE: ['engine-stand-type', 'FLEET_STATUS', 'Engine Stand Type'],
  LANDING_GEAR_FLEET_STATUS: [
    'landing-gear/fleet-status',
    'FLEET_STATUS',
    'Landing Gears',
  ],
  LANDING_GEAR_SUB_ASSEMBLY_FLEET: [
    'landing-gear/fleet-status',
    'MODULE_FLEET',
    'Landing Gear Sub-Assembly',
  ],
  AIRCRAFT_CENTRE: createFleetConfig('aircraft', 'Aircrafts'),
  AIRCRAFT: createFleetConfig('aircraft', 'Aircrafts'),
  ENGINE: createFleetConfig('engine', 'Engines'),
  ENGINE_CENTRE: createFleetConfig('engine', 'Engines'),
  LANDING_GEAR_CENTRE: createFleetConfig('landing-gear', 'Landing Gears'),
  APU_CENTRE: createFleetConfig('apu', 'APUs'),
};
